import { render, staticRenderFns } from "./NotificationTemplateForm.vue?vue&type=template&id=326b0317&scoped=true&"
import script from "./NotificationTemplateForm.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplateForm.vue?vue&type=style&index=0&id=326b0317&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b0317",
  null
  
)

export default component.exports